import React from 'react';
import LegalPage from './LegalPage';

export default function DateSafety() {
  return <LegalPage pageKey="dateSafety" />;
}
